import { render, staticRenderFns } from "./planets-visibility.vue?vue&type=template&id=bcefbd4a"
import script from "./planets-visibility.vue?vue&type=script&lang=js"
export * from "./planets-visibility.vue?vue&type=script&lang=js"
import style0 from "./planets-visibility.vue?vue&type=style&index=0&id=bcefbd4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports